import { createContextualCan } from "@casl/react";

import { AbilityContext } from "context/Ability.context";

export default createContextualCan(AbilityContext.Consumer);
